import { Link } from "react-router-dom";
import { ArrowRight, QrCode, Camera, Lightning, ShareNetwork, ChartLineUp } from "@phosphor-icons/react";
import AdSlot from "@/components/AdSlot";

const HERO_IMG =
    "https://images.unsplash.com/photo-1572534382964-664044795b84?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBob21lJTIwZXh0ZW5zaW9uJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzc4NDIxOTE1fDA&ixlib=rb-4.1.0&q=85";

const SHOWCASE_1 =
    "https://images.unsplash.com/photo-1754063257992-bb9eabdbdd86?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBob21lJTIwZXh0ZW5zaW9uJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzc4NDIxOTE1fDA&ixlib=rb-4.1.0&q=85";
const SHOWCASE_2 =
    "https://images.unsplash.com/photo-1772475385426-ebd50c772229?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBraXRjaGVuJTIwcmVtb2RlbCUyMG1pbmltYWx8ZW58MHx8fHwxNzc4NDIxOTE2fDA&ixlib=rb-4.1.0&q=85";
const SHOWCASE_3 =
    "https://images.unsplash.com/photo-1772475385491-f3cf64d4131a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBraXRjaGVuJTIwcmVtb2RlbCUyMG1pbmltYWx8ZW58MHx8fHwxNzc4NDIxOTE2fDA&ixlib=rb-4.1.0&q=85";
const BUILDER_PORTRAIT =
    "https://images.unsplash.com/photo-1530983822321-fcac2d3c0f06?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwyfHxidWlsZGVyJTIwY29udHJhY3RvciUyMHBvcnRyYWl0fGVufDB8fHx8MTc3ODQyMTkxNXww&ixlib=rb-4.1.0&q=85";

const SPECIALTIES = [
    "EXTENSIONS",
    "RENOVATIONS",
    "BRICKWORK",
    "LANDSCAPING",
    "CARPENTRY",
    "ROOFING",
    "PLASTERING",
    "KITCHENS",
    "BATHROOMS",
    "LOFT CONVERSIONS",
];

export default function Landing() {
    return (
        <div className="hero-bg">
            {/* HERO */}
            <section className="max-w-7xl mx-auto px-6 lg:px-10 pt-12 pb-20">
                <div className="bento">
                    <div className="col-span-12 md:col-span-7 fade-in-up">
                        <div className="inline-flex items-center gap-2 mb-6 border border-black px-3 py-1.5">
                            <span className="w-2 h-2 bg-[#E63946] rounded-full animate-pulse" />
                            <span className="text-overline">For UK Builders & Trades</span>
                        </div>
                        <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl font-black tracking-tighter leading-[0.92] uppercase">
                            Your portfolio.<br />
                            <span className="text-[#E63946]">One QR code.</span><br />
                            More jobs.
                        </h1>
                        <p className="mt-8 max-w-xl text-base sm:text-lg text-neutral-600 leading-relaxed">
                            BuildersGallery is the no-fuss way for British builders to show off
                            previous work. Upload your projects, get a shareable QR code, and let
                            customers see proof on the spot.
                        </p>
                        <div className="mt-10 flex flex-wrap items-center gap-4">
                            <Link to="/register" data-testid="hero-cta-register" className="btn-accent">
                                Create your gallery <ArrowRight size={16} weight="bold" />
                            </Link>
                            <Link to="/discover" data-testid="hero-cta-discover" className="btn-ghost">
                                See builders' work
                            </Link>
                        </div>
                        <div className="mt-10 flex items-center gap-6">
                            <img src={BUILDER_PORTRAIT} alt="" className="w-12 h-12 object-cover grayscale" />
                            <p className="text-xs text-neutral-600 max-w-xs leading-relaxed">
                                <span className="font-bold text-black">Free to use.</span> No hidden fees, no commission. Built for the trade.
                            </p>
                        </div>
                    </div>
                    <div className="col-span-12 md:col-span-5 fade-in-up" style={{ animationDelay: "120ms" }}>
                        <div className="relative">
                            <div className="absolute -top-3 -left-3 right-3 bottom-3 bg-[#E63946]" />
                            <img
                                src={HERO_IMG}
                                alt="Modern home extension"
                                className="relative w-full aspect-[4/5] object-cover"
                            />
                            <div className="absolute bottom-4 left-4 right-4 bg-white p-4 border border-black">
                                <div className="text-overline text-[#E63946] mb-1">Featured project</div>
                                <div className="font-display text-lg font-bold leading-tight">
                                    Timber & black-clad rear extension
                                </div>
                                <div className="text-xs text-neutral-600 mt-1">Bristol, UK</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* MARQUEE */}
            <section className="border-y-2 border-black bg-black text-white py-5 marquee">
                <div className="marquee-track font-display text-2xl font-black tracking-tight">
                    {[...SPECIALTIES, ...SPECIALTIES].map((s, i) => (
                        <span key={i} className="flex items-center gap-16">
                            {s} <span className="text-[#E63946]">★</span>
                        </span>
                    ))}
                </div>
            </section>

            {/* HOW IT WORKS */}
            <section className="max-w-7xl mx-auto px-6 lg:px-10 py-24">
                <AdSlot slot="hero" variant="banner" className="mb-16" />
                <div className="grid md:grid-cols-12 gap-10 items-end mb-14">
                    <div className="md:col-span-7">
                        <div className="text-overline text-[#E63946] mb-3">How it works</div>
                        <h2 className="font-display text-4xl sm:text-5xl font-black tracking-tighter leading-none uppercase">
                            Three steps. No nonsense.
                        </h2>
                    </div>
                    <p className="md:col-span-5 text-neutral-600">
                        Spend less time selling yourself and more time on site. We handle the digital handshake.
                    </p>
                </div>

                <div className="grid md:grid-cols-3 gap-0 border border-black">
                    {[
                        {
                            n: "01",
                            icon: Camera,
                            title: "Upload your work",
                            text: "Snap photos on site or pull from your gallery. Drag, drop, done.",
                        },
                        {
                            n: "02",
                            icon: QrCode,
                            title: "Get your QR code",
                            text: "We generate a personal QR linked to your live portfolio page.",
                        },
                        {
                            n: "03",
                            icon: ShareNetwork,
                            title: "Share with customers",
                            text: "Print on cards, vans, flyers. Customers scan and see your craft.",
                        },
                    ].map((step, i) => {
                        const Icon = step.icon;
                        return (
                            <div
                                key={step.n}
                                className={`p-8 ${i < 2 ? "md:border-r border-black" : ""} ${i < 2 ? "border-b md:border-b-0" : ""} bg-white hover:bg-[#FAFAFA] transition-colors`}
                            >
                                <div className="flex items-start justify-between mb-8">
                                    <Icon size={36} weight="duotone" />
                                    <span className="font-mono-accent text-sm text-neutral-400">{step.n}</span>
                                </div>
                                <h3 className="font-display text-2xl font-bold tracking-tight mb-2">{step.title}</h3>
                                <p className="text-sm text-neutral-600 leading-relaxed">{step.text}</p>
                            </div>
                        );
                    })}
                </div>
            </section>

            {/* SHOWCASE */}
            <section className="max-w-7xl mx-auto px-6 lg:px-10 py-12">
                <div className="text-overline text-[#E63946] mb-3">Built for craftsmanship</div>
                <h2 className="font-display text-4xl sm:text-5xl font-black tracking-tighter leading-none uppercase mb-12 max-w-2xl">
                    Photos that sell the work.
                </h2>
                <div className="grid grid-cols-12 gap-4">
                    <div className="col-span-12 md:col-span-7 aspect-[4/3]">
                        <img src={SHOWCASE_1} alt="" className="w-full h-full object-cover" />
                    </div>
                    <div className="col-span-6 md:col-span-5 aspect-[4/3]">
                        <img src={SHOWCASE_2} alt="" className="w-full h-full object-cover" />
                    </div>
                    <div className="col-span-6 md:col-span-5 aspect-[4/3]">
                        <img src={SHOWCASE_3} alt="" className="w-full h-full object-cover" />
                    </div>
                    <div className="col-span-12 md:col-span-7 aspect-[4/3] bg-black text-white p-10 flex flex-col justify-between">
                        <div>
                            <div className="text-overline text-[#E63946] mb-3">Why builders use us</div>
                            <p className="font-display text-3xl font-bold leading-tight">
                                "Quoted a £40k extension last week. The customer asked to see past work — I held up my QR sticker. Job won."
                            </p>
                        </div>
                        <div className="flex items-center gap-3">
                            <div className="w-10 h-10 bg-[#E63946]" />
                            <div>
                                <div className="font-bold text-sm">Mark T.</div>
                                <div className="text-xs text-neutral-400 uppercase tracking-wider">Builder · Manchester</div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* FEATURES */}
            <section className="max-w-7xl mx-auto px-6 lg:px-10 py-24">
                <div className="grid md:grid-cols-3 gap-12">
                    {[
                        { icon: Lightning, title: "Set up in 2 minutes", text: "No website skills. No upfront cost. Just a phone." },
                        { icon: ChartLineUp, title: "Convert quotes faster", text: "Visual proof closes more leads — show, don't tell." },
                        { icon: QrCode, title: "Reusable QR forever", text: "Add new jobs anytime. The QR keeps pointing to your latest work." },
                    ].map((f) => {
                        const Icon = f.icon;
                        return (
                            <div key={f.title} className="border-l-2 border-[#E63946] pl-5">
                                <Icon size={28} weight="duotone" className="mb-4" />
                                <h3 className="font-display text-xl font-bold mb-2">{f.title}</h3>
                                <p className="text-sm text-neutral-600 leading-relaxed">{f.text}</p>
                            </div>
                        );
                    })}
                </div>
            </section>

            {/* CTA */}
            <section className="max-w-7xl mx-auto px-6 lg:px-10 pb-24">
                <div className="bg-black text-white p-10 sm:p-16 grid md:grid-cols-12 gap-8 items-center">
                    <div className="md:col-span-8">
                        <div className="text-overline text-[#E63946] mb-3">Start today</div>
                        <h2 className="font-display text-4xl sm:text-5xl font-black tracking-tighter leading-none uppercase">
                            Your next customer is one scan away.
                        </h2>
                    </div>
                    <div className="md:col-span-4 flex md:justify-end">
                        <Link to="/register" data-testid="cta-bottom-register" className="btn-accent">
                            Get my gallery <ArrowRight size={16} weight="bold" />
                        </Link>
                    </div>
                </div>
            </section>
        </div>
    );
}
